import { render, staticRenderFns } from "./editMainCategory.vue?vue&type=template&id=70fe4aee"
import script from "./editMainCategory.vue?vue&type=script&lang=js"
export * from "./editMainCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports